"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../shared/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledIconButton = _styledComponents.default.button.withConfig({
  displayName: "IconButtonstyles__StyledIconButton",
  componentId: "sc-s5d1qq-0"
})(["display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;font-size:14px;line-height:16px;font-family:Gilroy-Medium;text-align:center;background:transparent;border:1px solid transparent;outline:none;cursor:pointer;color:", ";padding:0px;&:disabled{cursor:initial;}&.primary{background-color:", ";border-color:", ";&:hover{background-color:", ";border-color:", ";.icon,.icon path{fill:", ";}}&:focus{background-color:", ";border-color:", ";.icon,.icon path{fill:", ";}}&:active{background-color:", ";border-color:", ";.icon,.icon path{fill:", ";}}&:disabled{background-color:", ";border-color:", ";.icon,.icon path{fill:", ";}}}", " ", ""], _index.theme.palette.brand.primary.charcoal, _index.theme.palette.brand.primary.white, _index.theme.palette.brand.primary.charcoal, _index.theme.palette.brand.primary.gray, _index.theme.palette.brand.primary.gray, _index.theme.palette.brand.primary.white, _index.theme.palette.brand.primary.white, _index.theme.palette.ui.cta.yellow, _index.theme.palette.brand.primary.charcoal, _index.theme.palette.ui.neutral.grey1, _index.theme.palette.ui.neutral.grey1, _index.theme.palette.brand.primary.white, _index.theme.palette.ui.neutral.grey8, _index.theme.palette.ui.neutral.grey8, _index.theme.palette.brand.primary.white, ({
  buttonSize
}) => `
    width: ${buttonSize ? buttonSize : '40px'};
    height: ${buttonSize ? buttonSize : '40px'};
  `, ({
  isRounded
}) => `
    ${isRounded && `
      border-radius: 50%;
    `}
  `);

exports.StyledIconButton = StyledIconButton;